import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import qs from 'query-string';
import { path } from 'ramda';
import { axiosBeelineRequest } from '@beef/utils';
import { getFromLocalStorage, putToLocalStorage } from "../ChatWithOperator/utils";
import guid from "../../utils/guid-generator";
export var SET_FEEDBACK_MODEL = 'set feedback model';
export var SET_TOPICS = 'set topics';
export var SET_SETTINGS = 'set settings';
export var SET_CHAT_ID = 'set chat id';
export var SET_CUSTOMER_ID = 'set customer id';
export var UPDATE_MESSAGES = 'update messages';
export var SET_CHAT_URL = 'set chat URL';
export var SET_STEP = 'set step';
export var SET_LOGIN = 'set login';
export var SET_TOKEN = 'set token';
export var SET_POLLING_KEY = 'set polling key';
export var SET_GROUPS_TOKEN = 'set groups token';
export var SET_SOUND_NOTIFICATION = 'set sound notification';
export var SET_BUTTON_NOTIFICATION = 'set button notification';
export var RESET_CHAT = 'reset all chat data';
export var PUT_ERROR_MESSAGE = 'put error message';
var CHAT_URL = '';
var fetchParams = {
  clientProtocol: 1.5,
  connectionData: '[{"name":"chat"}]'
};
var checkChatEnds = function checkChatEnds() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var endCodes = [1, 2, 3];
  return messages.findIndex(function (item) {
    return endCodes.indexOf(item.Code) > -1;
  }) > -1;
};
var fetchSomething = function fetchSomething(params) {
  if (fetchParams.end) {
    return Promise.reject();
  }
  var isPlain = typeof params === 'string';
  var url = CHAT_URL + (isPlain ? params : params.url);
  return axiosBeelineRequest(_objectSpread(_objectSpread({}, params), {}, {
    url: url,
    originalResponse: true
  }));
};
var handleError = function handleError(dispatch) {
  return function () {
    putToLocalStorage('chat_sessionId', 'null');
    dispatch({
      type: SET_STEP,
      payload: 'error'
    });
    dispatch({
      type: RESET_CHAT
    });
  };
};

// шаг 1.1 - получаем список тем
var setTopics = function setTopics() {
  return function (dispatch, getState) {
    var region = getState().external.chatWithOperator.chatParams.chatRegionCode;
    var restricted = getState().external.chatWithOperator.chatParams.restrictTopics || '';
    restricted = restricted.toLowerCase();
    var restrictedArray = typeof restricted === 'string' ? restricted.split(',') : restricted;
    fetchSomething("Api/Topics?region=".concat(region)).then(function (resp) {
      var topics = restrictedArray ? resp.data.filter(function (item) {
        return restrictedArray.indexOf(item.Id) > -1;
      }) : resp.data;
      dispatch({
        type: SET_TOPICS,
        payload: topics.length > 0 ? topics : resp.data
      });
      dispatch(setSettings());
    }).catch(handleError(dispatch));
  };
};

// шаг 1.2 - получаем настройки
var setSettings = function setSettings() {
  return function (dispatch) {
    return fetchSomething('Api/Settings').then(function (_ref) {
      var data = _ref.data;
      dispatch({
        type: SET_SETTINGS,
        payload: data
      });
      var customerId = getFromLocalStorage('chat_customerId');
      var chatId = getFromLocalStorage('chat_sessionId');
      if (customerId) {
        dispatch({
          type: SET_CUSTOMER_ID,
          payload: customerId
        });
      }
      if (chatId) {
        dispatch(negotiateWithOperator());
      } else {
        dispatch({
          type: SET_STEP,
          payload: 'login'
        });
      }
    }).catch(handleError(dispatch));
  };
};

// 6.1 - подключение к уже созданному на бэке чату
var connectToChatSession = function connectToChatSession() {
  return function (dispatch) {
    var chatId = getFromLocalStorage('chat_sessionId');
    fetchSomething({
      method: 'post',
      url: "signalr/send?".concat(qs.stringify(fetchParams)),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: qs.stringify({
        data: "{\"H\":\"chat\",\"M\":\"ConnectToChatSession\",\"A\":[null,true],\"I\":0,\"S\":{\"chatSessionId\":\"".concat(chatId, "\"}}")
      })
    }).then(function (_ref2) {
      var data = _ref2.data;
      if (data && data.I == 0 && !data.R) {
        // eslint-disable-line
        dispatch(endChat(true));
        return;
      }
      if (path(['R', 'Data', 'Messages'], data)) {
        if (checkChatEnds(data.R.Data.Messages)) {
          dispatch(endChat(true));
          return;
        }
        dispatch({
          type: UPDATE_MESSAGES,
          payload: {
            messages: data.R.Data.Messages,
            init: true
          }
        });
      }
    }).catch(handleError(dispatch));
  };
};
var checkConnectionManager = function checkConnectionManager(body) {
  return function (dispatch) {
    fetchSomething({
      method: 'get',
      url: "signalr/reconnect?".concat(qs.stringify(fetchParams)),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: qs.stringify(body)
    }).then(function () {
      dispatch(negotiateWithOperator());
    }).catch(function () {
      setTimeout(function () {
        dispatch(checkConnectionManager(body));
      }, 5000);
    });
  };
};

// шаг 6.n - поллинг
var pollingManager = function pollingManager() {
  return function (dispatch, getState) {
    if (fetchParams.end) {
      return;
    }
    var _getState$external$ch = getState().external.chatWithOperator,
      pollingKey = _getState$external$ch.pollingKey,
      groupsToken = _getState$external$ch.groupsToken;
    var body = {
      messageId: pollingKey
    };
    if (groupsToken) {
      body.groupsToken = groupsToken;
    }
    fetchSomething({
      method: 'post',
      url: "signalr/poll?".concat(qs.stringify(fetchParams)),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: qs.stringify(body)
    }).then(function (_ref3) {
      var data = _ref3.data;
      if (data.G) {
        dispatch({
          type: SET_GROUPS_TOKEN,
          payload: data.G
        });
      }
      if (data.M && data.M.length > 0) {
        if (checkChatEnds(data.M[0].A)) {
          dispatch(endChat());
        }
        dispatch({
          type: UPDATE_MESSAGES,
          payload: {
            messages: data.M[0].A,
            init: false
          }
        });
      }
      dispatch({
        type: SET_POLLING_KEY,
        payload: data.C
      });
      dispatch(pollingManager());
    }).catch(function () {
      dispatch(checkConnectionManager(body));
    });
  };
};

// шаг 5 - старт поллинга
var startChatWithOperator = function startChatWithOperator() {
  return function (dispatch) {
    var params = qs.stringify(_objectSpread(_objectSpread({}, fetchParams), {}, {
      _: +new Date()
    }));
    fetchSomething("signalr/start?".concat(params)).then(function () {
      dispatch(pollingManager());
      dispatch(connectToChatSession());
    }).catch(handleError(dispatch));
  };
};

// шаг 4 - продолжение установки соединения
var connectWithOperator = function connectWithOperator() {
  return function (dispatch) {
    fetchSomething("signalr/connect?".concat(qs.stringify(fetchParams))).then(function (_ref4) {
      var data = _ref4.data;
      dispatch({
        type: SET_POLLING_KEY,
        payload: data.C
      });
      dispatch(startChatWithOperator());
    }).catch(handleError(dispatch));
  };
};

// шаг 3 - установка соединения
var negotiateWithOperator = function negotiateWithOperator() {
  return function (dispatch) {
    var params = qs.stringify(_objectSpread(_objectSpread({}, fetchParams), {}, {
      _: +new Date()
    }));
    fetchSomething("signalr/negotiate?".concat(params)).then(function (_ref5) {
      var data = _ref5.data;
      fetchParams.connectionToken = data.ConnectionToken;
      fetchParams.transport = 'longPolling';
      dispatch({
        type: SET_TOKEN,
        payload: data.ConnectionToken
      });
      dispatch({
        type: SET_STEP,
        payload: 'chat'
      });
      dispatch(connectWithOperator());
    }).catch(function () {
      dispatch({
        type: SET_STEP,
        payload: 'login'
      });
      dispatch({
        type: RESET_CHAT
      });
    });
  };
};

// шаг 2 - инициализация чата введенными данными
export var submitLoginForm = function submitLoginForm(payload) {
  return function (dispatch) {
    putToLocalStorage('chat_userName', payload.CustomerName);
    return fetchSomething({
      method: 'post',
      url: 'api/ChatSessions',
      data: qs.stringify(payload)
    }).then(function (_ref6) {
      var data = _ref6.data;
      if (data.EndedAt) {
        dispatch(reopenLoginForm());
        return;
      }
      dispatch({
        type: SET_CUSTOMER_ID,
        payload: data.CustomerId
      });
      dispatch({
        type: SET_CHAT_ID,
        payload: data.Id
      });
      dispatch({
        type: SET_LOGIN,
        payload: data.CustomerPhoneNumber
      });
      dispatch(negotiateWithOperator());
      putToLocalStorage('chat_customerId', data.CustomerId);
      putToLocalStorage('chat_sessionId', data.Id);
      putToLocalStorage('chat_login', payload.CustomerPhoneNumber);
    }).catch(function (result) {
      var errorCode = path(['response', 'data', 'errorCode'], result);
      if (errorCode === 66) {
        return Promise.reject(new Error('captcha'));
      }
      if (errorCode === 73) {
        return Promise.reject(new Error('noOnline'));
      }
      return 'other';
    });
  };
};

// шаг 1 - инициализация сессии
export var initSession = function initSession() {
  return function (dispatch, getState) {
    CHAT_URL = "".concat(path(['external', 'chatWithOperator', 'chatParams', 'chatDomain'], getState()), "/");
    dispatch({
      type: SET_STEP,
      payload: 'loading'
    });
    dispatch({
      type: SET_CUSTOMER_ID,
      payload: getFromLocalStorage('chat_customerId')
    });
    dispatch({
      type: SET_CHAT_ID,
      payload: getFromLocalStorage('chat_sessionId')
    });
    dispatch({
      type: SET_LOGIN,
      payload: getFromLocalStorage('chat_login')
    });
    dispatch({
      type: SET_CHAT_URL,
      payload: CHAT_URL
    });
    dispatch(setTopics());
  };
};
export var sendMessage = function sendMessage(text) {
  return function (dispatch, getState) {
    var chatId = getState().external.chatWithOperator.chatId;
    return fetchSomething({
      method: 'post',
      url: "signalr/send?".concat(qs.stringify(fetchParams)),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: qs.stringify({
        // eslint-disable-next-line max-len
        data: "{\"H\":\"chat\",\"M\":\"SendChatMessage\",\"A\":[".concat(JSON.stringify(text), ",false],\"I\":1,\"S\":{\"chatSessionId\":\"").concat(chatId, "\"}}")
      })
    });
  };
};
export var uploadFile = function uploadFile(file) {
  return function (dispatch, getState) {
    var _getState$external$ch2 = getState().external.chatWithOperator,
      customerId = _getState$external$ch2.customerId,
      chatId = _getState$external$ch2.chatId;
    var formData = new FormData();
    formData.append('fileToUpload', file);
    formData.append('requestId', guid());
    formData.append('chatSessionId', chatId);
    formData.append('customerId', customerId);
    return axiosBeelineRequest({
      originalResponse: true,
      data: formData,
      url: "".concat(CHAT_URL, "api/File"),
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
};
export var endChat = function endChat(initial) {
  return function (dispatch, getState) {
    var chatId = getState().external.chatWithOperator.chatId;
    function closeChatSession() {
      fetchParams.end = true;
      if (!initial) {
        dispatch({
          type: SET_STEP,
          payload: 'end'
        });
      }
      putToLocalStorage('chat_sessionId', 'null');
    }
    fetchSomething({
      method: 'post',
      url: "signalr/send?".concat(qs.stringify(fetchParams)),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: qs.stringify({
        data: "{\"H\":\"chat\",\"M\":\"CloseChatSession\",\"A\":[\"".concat(chatId, "\"],\"I\":3,\"S\":{\"chatSessionId\":\"").concat(chatId, "\"}}")
      })
    }).then(function () {
      return fetchSomething({
        method: 'post',
        url: "signalr/abort?".concat(qs.stringify(fetchParams))
      }).then(closeChatSession);
    }).catch(closeChatSession);
  };
};
export var reopenLoginForm = function reopenLoginForm() {
  return function (dispatch) {
    delete fetchParams.end;
    dispatch({
      type: SET_STEP,
      payload: 'login'
    });
    dispatch({
      type: RESET_CHAT
    });
  };
};
export var setSoundNotification = function setSoundNotification(payload) {
  return function (dispatch) {
    dispatch({
      type: SET_SOUND_NOTIFICATION,
      payload: payload
    });
  };
};
export var setButtonNoNotification = function setButtonNoNotification(payload) {
  return function (dispatch) {
    dispatch({
      type: SET_BUTTON_NOTIFICATION,
      payload: payload
    });
  };
};
export var putErrorMessage = function putErrorMessage(payload) {
  return function (dispatch) {
    dispatch({
      type: PUT_ERROR_MESSAGE,
      payload: payload
    });
  };
};